import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";
import { WorkoutProgramDetailComponent } from './workout-program-detail/workout-program-detail.component';

@Component({
  selector: 'vex-workout-programs',
  templateUrl: './workout-programs.component.html',
  styleUrls: ['./workout-programs.component.scss']
})
export class WorkoutProgramsComponent implements OnInit {
  environment = environment.baseURL.workout_programs;
  previousUrl;

  constructor(public guiService: GuiService, public translate: TranslateService, private dialog: MatDialog, private router: Router) {
    this.router.events
            .subscribe((event) => {
              if (event instanceof NavigationStart) {
                this.previousUrl = this.router.url;
              }
            });
   }

  ngOnInit(){
    this.guiService.showSpinner = false;
    if(this.guiService.programs.length < 1){
      this.guiService.getPrograms();
      localStorage.getItem('tourWorkoutProgramsShowed') ? null : this.startTour();
    }
  }

  openModalProgramDetail(program: any, colorClass: string): void {
  const dialogRef = this.dialog.open(WorkoutProgramDetailComponent, {
    width: '90%',
    maxWidth: '600px',
    data: { program, colorClass },
    disableClose: true // disabilita chiusura su click fuori
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result?.redirect === 'goHome') {
      this.router.navigate(['main/home']);
    }
  });
}


  startTour(): void {
    localStorage.setItem('tourWorkoutProgramsShowed', 'true')

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.workout-programs-title', popover: { title: this.translate.instant('TUTORIALS.workout-programs.discoverTitle'), description: this.translate.instant('TUTORIALS.workout-programs.discoverDescription') } },
        { element: '.program', popover: { title: this.translate.instant('TUTORIALS.workout-programs.detailsTitle'), description: this.translate.instant('TUTORIALS.workout-programs.detailsDescription') } }
      ]
    });

    driverObj.drive();
  }

}
